export default "__VITE_ASSET__BDBrHFSo__"